<template lang="pug">
  .waitlist-form
    form(v-if="!joinedWaitlist && !onWaitlist" @submit.prevent="add")
      p.xs-f-xmedium.max-at-tweak This product is {{inventoryStatus == 'coming_soon' ? 'coming soon' : 'out of stock'}}
      p.notify-text.xs-f-small.max-at-tweak Notify me when it's available
      mr-input.email-input(label="Email" input-type="email" v-model="email" :v="$v.email" required)
      button.submit-btn.mr-btn.xs-f-xsmall.max-at-tweak sign up

    p.xs-f-xmedium.max-at-tweak(v-else role="alert") Your email has been added to the waitlist

</template>

<script>
  const { required, email } = require("vuelidate/lib/validators");

  import { mapGetters, mapActions } from 'vuex';
  import mrInput from '../mrInput';

  export default {
    name: "WaitlistForm",

    components: {
      mrInput
    },

    props: {
      productId: {
        type: Number
      },

      inventoryStatus: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        email: null,
        joinedWaitlist: false
      }
    },

    validations: {
      email: {
        required,
        email
      }
    },

    computed: {
      ...mapGetters('waitlist', ['isOnWaitlist']),

      onWaitlist() {
        return this.isOnWaitlist('product_waitlist', this.productId);
      }
    },

    methods: {
      ...mapActions('waitlist', ['initWaitlists', 'addToWaitlist']),

      add() {
        if (!this.joinedWaitlist) {
          this.addToWaitlist({
            email: this.email,
            waitlist_type: 'product_waitlist',
            product_id: this.productId
          });
          this.joinedWaitlist = true;
        }
      }
    },

    created() {
      this.initWaitlists();
    }
  }
</script>

<style scoped lang="stylus">
  .waitlist-form
    .notify-text
      margin-bottom 1em
      
    .email-input
    .submit-btn
      display inline-block
      vertical-align top
    
    .email-input
      width 65%
      margin-right 0.5em
      margin-top 0
      
    .submit-btn
      width 30%
      padding-left 0.5em
      padding-right 0.5em
      height 44px
    
</style>
